import $ from "jquery";
import RMScroll from "@rmlibrary/scroll";

const lang = document.documentElement.lang.toLowerCase().indexOf("fr") >= 0 ? "fr" : "en";
const accordions = document.getElementsByClassName("accordion");

for (let i = 0; i < accordions.length; i++) {
    const accordion = accordions[i];

    accordion.addEventListener("click", () => {
        if (accordion.classList.contains("disabled")) {
            return false;
        }

        const panel = accordion.nextElementSibling;

        accordion.classList.toggle("on");
        if (!accordion.classList.contains("on")) {
            const element = $(accordion).find("[data-view]");
            if (element) {
                const text = lang === "en" ? "View more" : "Détails";
                $(element).html(text);
            }

            $(accordion).find("button").attr("aria-expanded", false);

            $(panel)
                .css({
                    display: "block",
                    overflow: "hidden"
                })
                .css({ maxHeight: panel.scrollHeight })
                .animate({ maxHeight: 0 }, "swing", () => {
                    panel.style.maxHeight = "";
                    panel.style.display = "none";
                });
        } else {
            const element = $(accordion).find("[data-view]");
            if (element) {
                const text = lang === "en" ? "View less" : "Cacher les détails";
                $(element).html(text);
            }

            $(accordion).find("button").attr("aria-expanded", true);

            $(panel)
                .css({ display: "block", maxHeight: 0 })
                .animate({ maxHeight: panel.scrollHeight }, 300, "swing", () => {
                    panel.style.maxHeight = "none";
                    panel.style.overflow = "visible";

                    if (!$(panel).hasClass("scrolled-once")) {
                        const elements = document.querySelectorAll(
                            ".infographic-container, .cash-flow, .legal-disclaimer"
                        );
                        if (elements.length > 0 && !$(panel).hasClass("ignore-window-scroll")) {
                            $("html, body").animate(
                                {
                                    scrollTop: $(accordion).offset().top
                                },
                                500
                            );
                        }
                        $(panel).addClass("scrolled-once");
                    }
                });

            // Triggle CJS Animation resizes
            setTimeout(() => {
                if (typeof Event === "function") {
                    // modern browsers
                    window.dispatchEvent(new Event("resize"));
                } else {
                    // for IE and other old browsers
                    // causes deprecation warning on modern browsers
                    var evt = window.document.createEvent("UIEvents");
                    evt.initUIEvent("resize", true, false, window, 0);
                    window.dispatchEvent(evt);
                }
                RMScroll.scrollTrigger();
            }, 200);
        }
    });
}
